import { AxiosResponse } from "axios";
import { apiGetRequest, apiPostRequest, createPayload } from "./util/apiUtils";
import { Endpoint, ragMemberSecretKey } from "./util/contants";
import { HitlMessageResponse } from "./responsePayload/HitlMessageResponse";
import { MessageStatus } from "../pages/chatbot/dataModel/ChatBotDataModel";
import { PageResponse } from "./responsePayload/PageResponse";
import { ChatConversation } from "./responsePayload/ChatResponse";
import { mapChatHistoryResponse } from "./util/chatMapper";
import { ChatbotResponse } from "./responsePayload/ChatbotResponse";

export const RagChat = async (
  message: string,
  threadId: string,
  memberId: string,
  teamId: string,
  member_secret_key: string
): Promise<ChatbotResponse | null> => {
  const basePayload = {
    message: message,
    thread_id: threadId,
    member_id: memberId,
    team_id: teamId,
    member_secret_key: member_secret_key,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest<ChatbotResponse>(Endpoint.Ragchat, payload);
};

export const chatbotUserMessage = async (
  message: string,
  threadId: string,
  memberId: number,
  teamId: number
): Promise<AxiosResponse | null> => {
  const basePayload = {
    message: message,
    // thread_id: threadId,
    member_id: memberId,
    team_id: teamId,
    member_secret_key: ragMemberSecretKey,
  };
  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.chatbotUserMessage, payload);
};

export const chatbotHitlMessage = async (
  message: string,
  memberId: number,
  messageStatus: MessageStatus,
  messageId?: string,
  image_urls?: string[]
): Promise<AxiosResponse | null> => {
  const basePayload = {
    ...(messageStatus != MessageStatus.Approve ? { message: message } : {}),
    ...(image_urls && { image_urls: image_urls }),
    member_id: memberId,
    message_status: messageStatus,
    ...(messageId ? { message_id: messageId } : {}),
  };
  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.chatbotHitlMessage, payload);
};

export const getChatbotHitlMessage = async (
  memberId: number,
  current: boolean = false
): Promise<HitlMessageResponse | undefined> => {
  return await apiGetRequest<HitlMessageResponse>(
    Endpoint.chatbotHitlMessage,
    {},
    {
      member_id: memberId,
      current: current,
    }
  );
};

export const getChatRoomStatus = async (
  id: number
): Promise<AxiosResponse | undefined> => {
  return await apiGetRequest<AxiosResponse>(Endpoint.chatRoomStatus, {
    id: id,
  });
};

export const endConversation = async (
  memberId: number
): Promise<AxiosResponse | null> => {
  const basePayload = {
    member_id: memberId,
  };
  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.chatbotEndConservation, payload);
};

export const chatHistory = async (
  endpoint: string | undefined = Endpoint.chatHistory,
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {},
  page: number | undefined = undefined
): Promise<PageResponse<ChatConversation> | null> => {
  const query = {
    ...queryParams,
    page: page,
  };

  const path = {
    ...pathVariables,
    id: undefined,
  };
  const res = await apiGetRequest(endpoint, path, query);
  if (!res) return null;

  return mapChatHistoryResponse(res);
};
